// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryBody__root--2VihO","hidden":"StoryBody__hidden--284qb","item":"StoryBody__item--1cHYD","paragraph":"StoryBody__paragraph--2-Doz","caption":"StoryBody__caption--z-cgi","subhead":"StoryBody__subhead--3hgz5","factsMatter":"StoryBody__factsMatter--MiwD4","link":"StoryBody__link--10w8x","orderedList":"StoryBody__orderedList--3hKT0","bounce":"StoryBody__bounce--1aTcv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoryBody/StoryBody.css
// module id = ./src/components/Library/StoryBody/StoryBody.css
// module chunks = 2